import React from "react";
import IncompleteRequestsDashboard from "../components/requests/IncompleteRequestsDashboard";

export default function IncompleteMedicalRequestsPage() {
  return <IncompleteRequestsDashboard scope="medical" />;
}
